import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
/* import Home from './components/Home/Home'; */
import Header from './components/Layout/Header/Header';
import Footer from './components/Layout/Footer/Footer';
import AuthGuard from './components/Guards/GuardAuth';
import ProfileGuard from './components/Guards/ProfileGuard';
import CreateUser from './components/Sections/CreateUser/CreateUser';
import CreateRestaurant from './components/Sections/createRestaurant/CreateRestaurant';
import DetalleRestaurante from './components/Sections/DetalleRestaurante/DetalleRestaurante';
import WorkWithUs from './components/Sections/CreateUser/WorkWithUs/WorkWithUs';
import MyRestaurants from './components/Sections/MyRestaurants/MyRestaurants';
import EditMyRestaurant from './components/Sections/MyRestaurants/EditMyRestaurant/EditMyRestaurant';
import HacerPedido from './components/Sections/DetalleRestaurante/HacerPedido/HacerPedido';
import PedidosRestaurante from './components/Sections/DetalleRestaurante/PedidosRestaurante/PedidosRestaurante';
import HomeRepartidor from './components/Home/HomeRepartidor/HomeRepartidor';
import RestauranteIsActive from './components/Sections/createRestaurant/RestauranteIsActive/RestauranteIsActive';
import MyOrders from './components/Home/HomeRepartidor/MyOrdes/MyOrders';
import OrderByUser from './components/Sections/User/OrderByUser/OrderByUser';
import AdminInactiveUsers from './components/Sections/AdminInactive/AdminInactiveUsers/AdminInactiveUsers';
import AdminPayments from './components/Sections/AdminReports/AdminPayments/AdminPayments';
import Success from './components/Sections/Payment/Success/Success';
import Pending from './components/Sections/Payment/Pending/Pending';
import Failure from './components/Sections/Payment/Failure/Failure';
import Error404 from './components/Layout/404/404';
import HomeCategorias from './components/Home/HomeCategorias/HomeCategorias';
import RestaurantsByCategory from './components/Home/HomeCategorias/RestaurantsByCategory/RestaurantsByCategory';
import RequestPasswordReset from './components/Guards/Auth/RequestPasswordReset';
import ResetPassword from './components/Guards/Auth/ResetPassword';

const Router = () => {
    return (
        <BrowserRouter>
            <ProfileGuard />
            <Header />
            <Routes>
                <Route
                    path="/"
                    element={
                        <AuthGuard>
                            <HomeCategorias />
                        </AuthGuard>
                    }
                />

                <Route
                    path="/categoria/:categoriaPrincipal"
                    element={
                        <AuthGuard>
                            <RestaurantsByCategory />
                        </AuthGuard>} />

                <Route
                    path="/courier/orders"
                    element={
                        <AuthGuard>
                            <HomeRepartidor />
                        </AuthGuard>
                    }
                />

                <Route
                    path="/courier/my-orders"
                    element={
                        <MyOrders />
                    }
                />

                <Route
                    path="/register"
                    element={
                        <CreateUser />
                    }
                />

                <Route
                    path="/register/work-with-us"
                    element={
                        <WorkWithUs />
                    }
                />

                <Route
                    path="/add-restaurants"
                    element={
                        <AuthGuard>
                            <CreateRestaurant />
                        </AuthGuard>
                    }
                />

                <Route
                    path="/restaurants/:id"
                    element={
                        <AuthGuard>
                            <DetalleRestaurante />
                        </AuthGuard>
                    }
                />
                <Route
                    path="/restaurants/get-my-restaurants"
                    element={
                        <AuthGuard>
                            <MyRestaurants />
                        </AuthGuard>
                    }
                />

                <Route
                    path="/restaurants/edit-my-restaurant/:restauranteId"
                    element={
                        <AuthGuard>
                            <EditMyRestaurant />
                        </AuthGuard>
                    }
                />

                <Route
                    path="/restaurants/:id/create-order/:orderId"
                    element={
                        <AuthGuard>
                            <HacerPedido />
                        </AuthGuard>
                    }
                />

                <Route
                    path="/restaurants/:restauranteId/orders"
                    element={
                        <AuthGuard>
                            <PedidosRestaurante />
                        </AuthGuard>
                    }
                />

                <Route
                    path="/restaurants/inactive"
                    element={
                        <AuthGuard>
                            <RestauranteIsActive />
                        </AuthGuard>
                    }
                />

                <Route
                    path="/users/:userId/orders"
                    element={
                        <AuthGuard>
                            <OrderByUser />
                        </AuthGuard>
                    }
                />

                <Route
                    path="/users/inactive"
                    element={
                        <AuthGuard>
                            <AdminInactiveUsers />
                        </AuthGuard>
                    }
                />

                <Route
                    path="/admin/reports/pagos"
                    element={
                        <AuthGuard>
                            <AdminPayments />
                        </AuthGuard>
                    }
                />

                <Route
                    path="/success"
                    element={
                        <AuthGuard>
                            <Success />
                        </AuthGuard>
                    }
                />

                <Route
                    path="/pending"
                    element={
                        <AuthGuard>
                            <Pending />
                        </AuthGuard>
                    }
                />

                <Route
                    path="/failure"
                    element={
                        <AuthGuard>
                            <Failure />
                        </AuthGuard>
                    }
                />

                <Route
                    path="*"
                    element={
                        <Error404 />
                    }
                />

                <Route
                    path="/forgot-password"
                    element={<RequestPasswordReset />}
                />

                <Route
                    path="/reset-password"
                    element={<ResetPassword />}
                />

            </Routes>
            <Footer />
        </BrowserRouter >
    )
}

export default Router;
